import { RedirectFunction, Router } from '@angular/router';
import { inject } from '@angular/core';
import { trimSlashes } from '@softline/core';

/**
 * Alters the redirect URL to be shell-environment-aware
 * @example Example usage of redirectFn()
 * // returns "/embedded/example" when the starting url includes "embedded";
 * // returns "/terminal/example" when the starting url includes "terminal"
 * // returns "/example" when the starting url includes does not include "embedded" nor "terminal"
 * {
 *   path: '**',
 *   redirectTo: redirectToFn("/example")
 * }
 * @param path the absolute path to the target (must start with "/")
 * @returns `RedirectFunction` for route 'redirectTo'
 */
export function redirectToFn(path: string): RedirectFunction {
  return () => {
    const router = inject(Router);
    const isEmbedded = router.url.includes('embedded');
    const isTerminal = router.url.includes('terminal');
    const prefixOrEmpty = isEmbedded ? '/embedded' : isTerminal ? '/terminal' : '';
    return `${prefixOrEmpty}/${trimSlashes(path, 'leading')}`;
  };
}
